import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import { Flex } from '@repo/ui/Flex';

import s from '../Input.module.css';

export const inputRootWidthOptions = ['default', 'full'] as const;
export type InputRootWidth = (typeof inputRootWidthOptions)[number];

export type InputRootProps = ComponentPropsWithRef<'div'> & {
  className?: string;
  children?: ReactNode;
  width?: InputRootWidth;
};

export const inputRootVariants = cva(s.root, {
  variants: {
    width: {
      default: s.defaultWidth,
      full: s.fullWidth,
    },
  },
  defaultVariants: {
    width: 'default',
  },
});

export const InputRoot = (props: InputRootProps) => {
  const { children, className, width = 'default', ...attrs } = props;

  return (
    <Flex
      direction="column"
      gap="g-8"
      className={clsx(inputRootVariants({ width }), className)}
      {...attrs}
    >
      {children}
    </Flex>
  );
};
